// axios
import axios from 'axios'

const baseURL = process.env.NODE_ENV === 'production' ? 'https://nihonsuperior.ideria.co' : ''

export default axios.create({
  baseURL,
  Authorization : localStorage.getItem('access_token') ? 'Bearer ' + localStorage.getItem('access_token') : null
})
